import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const Editors = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Editors" pageType="Forms" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Editor
            </h2>
              <div className="text-black">
                <div className="overflow-hidden bg-white border rounded-md border-black/10 dark:bg-darklight dark:border-darkborder">
                  <CKEditor
                    editor={ClassicEditor}
                    data={`
                  <h1>Hello World!</h1>
                  <p>Welcome to the pure AlpineJS and Tailwind sliced.</p>
                `}
                  />
                </div>
              </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Editors;
